export interface Badge {
    id: string;
    name: string;
    description: string;
    emoji: string;
}

// Insignias por libro y actividad
export const BADGES: { [bookNumber: number]: { [activityNumber: number]: Badge } } = {
    1: {
        1: {
            id: "sugar-detective",
            name: "Detective del Azúcar Oculto",
            description: "Por descubrir el azúcar oculto en los alimentos",
            emoji: "🔍"
        },
        2: {
            id: "truth-challenger",
            name: "Desafiante de la Verdad",
            description: "Por completar el reto de la verdad",
            emoji: "⚖️"
        },
        3: {
            id: "subjective-knowledge",
            name: "Conocedor Subjetivo",
            description: "Por explorar el conocimiento subjetivo",
            emoji: "🧠"
        },
        4: {
            id: "less-is-more",
            name: "Maestro de la Simplicidad",
            description: "Por comprender que a veces menos es más",
            emoji: "✨"
        },
        5: {
            id: "story-power",
            name: "Narrador Poderoso",
            description: "Por descubrir el poder de un buen cuento",
            emoji: "📚"
        },
        6: {
            id: "data-fragility",
            name: "Protector de Datos",
            description: "Por comprender la fragilidad de los datos",
            emoji: "🛡️"
        },
        7: {
            id: "financial-wisdom",
            name: "Sabio Financiero",
            description: "Por completar el desafío de la sabiduría financiera",
            emoji: "💰"
        }
    },
    2: {
        1: {
            id: "water-explorer",
            name: "Explorador del Agua",
            description: "Por descubrir las propiedades del agua",
            emoji: "💧"
        },
        2: {
            id: "density-scientist",
            name: "Científico de la Densidad",
            description: "Por experimentar con líquidos de diferentes densidades",
            emoji: "⚖️"
        },
        3: {
            id: "surface-tension-master",
            name: "Maestro de la Tensión Superficial",
            description: "Por explorar la tensión superficial del agua",
            emoji: "🌊"
        },
        4: {
            id: "capillary-action-explorer",
            name: "Explorador de la Acción Capilar",
            description: "Por observar cómo el agua sube por capilares",
            emoji: "📈"
        },
        5: {
            id: "evaporation-scientist",
            name: "Científico de la Evaporación",
            description: "Por experimentar con la evaporación del agua",
            emoji: "☁️"
        },
        6: {
            id: "condensation-master",
            name: "Maestro de la Condensación",
            description: "Por crear condensación y observar el ciclo del agua",
            emoji: "💦"
        },
        7: {
            id: "water-cycle-explorer",
            name: "Explorador del Ciclo del Agua",
            description: "Por comprender el ciclo completo del agua",
            emoji: "🔄"
        }
    },
    3: {
        1: {
            id: "air-explorer",
            name: "Explorador del Aire",
            description: "Por descubrir las propiedades del aire",
            emoji: "💨"
        },
        2: {
            id: "pressure-scientist",
            name: "Científico de la Presión",
            description: "Por experimentar con la presión del aire",
            emoji: "🌪️"
        },
        3: {
            id: "wind-master",
            name: "Maestro del Viento",
            description: "Por crear y controlar el viento",
            emoji: "🌬️"
        },
        4: {
            id: "balloon-scientist",
            name: "Científico de Globos",
            description: "Por experimentar con globos y el aire",
            emoji: "🎈"
        },
        5: {
            id: "parachute-designer",
            name: "Diseñador de Paracaídas",
            description: "Por crear paracaídas que flotan en el aire",
            emoji: "🪂"
        },
        6: {
            id: "windmill-builder",
            name: "Constructor de Molinos",
            description: "Por construir molinos que aprovechan el viento",
            emoji: "🏗️"
        },
        7: {
            id: "air-pressure-explorer",
            name: "Explorador de la Presión del Aire",
            description: "Por comprender cómo funciona la presión del aire",
            emoji: "📊"
        }
    },
    4: {
        1: {
            id: "earth-explorer",
            name: "Explorador de la Tierra",
            description: "Por descubrir los secretos de la tierra",
            emoji: "🌍"
        },
        2: {
            id: "soil-scientist",
            name: "Científico del Suelo",
            description: "Por experimentar con diferentes tipos de suelo",
            emoji: "🌱"
        },
        3: {
            id: "rock-collector",
            name: "Coleccionista de Rocas",
            description: "Por identificar y clasificar diferentes tipos de rocas",
            emoji: "🪨"
        },
        4: {
            id: "mineral-explorer",
            name: "Explorador de Minerales",
            description: "Por descubrir minerales y sus propiedades",
            emoji: "💎"
        },
        5: {
            id: "fossil-hunter",
            name: "Cazador de Fósiles",
            description: "Por buscar y encontrar fósiles",
            emoji: "🦕"
        },
        6: {
            id: "erosion-scientist",
            name: "Científico de la Erosión",
            description: "Por experimentar con la erosión del suelo",
            emoji: "🏔️"
        },
        7: {
            id: "earth-layers-explorer",
            name: "Explorador de Capas Terrestres",
            description: "Por comprender las capas de la Tierra",
            emoji: "🌋"
        }
    },
    5: {
        1: {
            id: "energy-explorer",
            name: "Explorador de la Energía",
            description: "Por descubrir diferentes formas de energía",
            emoji: "⚡"
        },
        2: {
            id: "motion-scientist",
            name: "Científico del Movimiento",
            description: "Por experimentar con el movimiento y la energía",
            emoji: "🏃"
        },
        3: {
            id: "gravity-master",
            name: "Maestro de la Gravedad",
            description: "Por comprender y experimentar con la gravedad",
            emoji: "🌌"
        },
        4: {
            id: "friction-explorer",
            name: "Explorador de la Fricción",
            description: "Por experimentar con la fricción y el movimiento",
            emoji: "🛷️"
        },
        5: {
            id: "momentum-scientist",
            name: "Científico del Momentum",
            description: "Por comprender el momentum y la inercia",
            emoji: "🎯"
        },
        6: {
            id: "potential-energy-master",
            name: "Maestro de la Energía Potencial",
            description: "Por experimentar con la energía potencial",
            emoji: "📏"
        },
        7: {
            id: "kinetic-energy-explorer",
            name: "Explorador de la Energía Cinética",
            description: "Por convertir energía potencial en cinética",
            emoji: "🎢"
        }
    },
    6: {
        1: {
            id: "electricity-explorer",
            name: "Explorador de la Electricidad",
            description: "Por descubrir los secretos de la electricidad",
            emoji: "⚡"
        },
        2: {
            id: "circuit-builder",
            name: "Constructor de Circuitos",
            description: "Por construir circuitos eléctricos simples",
            emoji: "🔌"
        },
        3: {
            id: "conductor-scientist",
            name: "Científico de Conductores",
            description: "Por experimentar con conductores y aislantes",
            emoji: "🔋"
        },
        4: {
            id: "switch-master",
            name: "Maestro de Interruptores",
            description: "Por crear interruptores para controlar circuitos",
            emoji: "🔘"
        },
        5: {
            id: "parallel-circuit-explorer",
            name: "Explorador de Circuitos Paralelos",
            description: "Por construir circuitos en paralelo",
            emoji: "🔄"
        },
        6: {
            id: "magnetic-generator-builder",
            name: "Constructor de Generadores Magnéticos",
            description: "Por crear generadores que producen electricidad",
            emoji: "⚙️"
        },
        7: {
            id: "magnetic-machine-designer",
            name: "Diseñador de Máquinas Magnéticas",
            description: "Por crear máquinas que funcionan con magnetismo",
            emoji: "🏭"
        }
    },
    7: {
        1: {
            id: "chemistry-explorer",
            name: "Explorador de la Química",
            description: "Por descubrir las reacciones químicas",
            emoji: "🧪"
        },
        2: {
            id: "acid-base-scientist",
            name: "Científico de Ácidos y Bases",
            description: "Por experimentar con ácidos y bases",
            emoji: "🧬"
        },
        3: {
            id: "ph-indicator-master",
            name: "Maestro de Indicadores de pH",
            description: "Por crear indicadores de pH naturales",
            emoji: "🌈"
        },
        4: {
            id: "chemical-reaction-explorer",
            name: "Explorador de Reacciones Químicas",
            description: "Por observar reacciones químicas seguras",
            emoji: "💥"
        },
        5: {
            id: "solution-scientist",
            name: "Científico de Soluciones",
            description: "Por crear y experimentar con soluciones",
            emoji: "🥤"
        },
        6: {
            id: "precipitation-master",
            name: "Maestro de Precipitación",
            description: "Por crear precipitados en reacciones químicas",
            emoji: "❄️"
        },
        7: {
            id: "chemical-change-explorer",
            name: "Explorador de Cambios Químicos",
            description: "Por distinguir cambios físicos y químicos",
            emoji: "🔄"
        }
    },
    8: {
        1: {
            id: "biology-explorer",
            name: "Explorador de la Biología",
            description: "Por descubrir los secretos de la vida",
            emoji: "🔬"
        },
        2: {
            id: "germination-scientist",
            name: "Científico de la Germinación",
            description: "Por hacer germinar semillas y observar el crecimiento",
            emoji: "🌱"
        },
        3: {
            id: "cell-observer",
            name: "Observador de Células",
            description: "Por observar células vegetales al microscopio",
            emoji: "🔍"
        },
        4: {
            id: "photosynthesis-master",
            name: "Maestro de la Fotosíntesis",
            description: "Por experimentar con la fotosíntesis",
            emoji: "☀️"
        },
        5: {
            id: "respiration-scientist",
            name: "Científico de la Respiración",
            description: "Por observar la respiración de las plantas",
            emoji: "🫁"
        },
        6: {
            id: "ecosystem-builder",
            name: "Constructor de Ecosistemas",
            description: "Por crear ecosistemas en miniatura",
            emoji: "🌍"
        },
        7: {
            id: "microscope-designer",
            name: "Diseñador de Microscopios",
            description: "Por construir microscopios simples",
            emoji: "🔬"
        }
    }
};

// Función para obtener una insignia específica
export function getBadge(bookNumber: number, activityNumber: number): Badge | null {
    return BADGES[bookNumber]?.[activityNumber] || null;
}

// Función para formatear fecha
export function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
} 